export default __webpack_public_path__ + "static/media/database-labs.ef0fc5f1.svg";